exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vacation-presence-name {\r\n  border-radius: 2px;\r\n}\r\n\r\n.vacation-presence-name--vacation {\r\n  background: #f1f7ff;\r\n  box-shadow: 0 0 0 2px #c7dcf5;\r\n}\r\n\r\n.vacation-presence-name--sick-leave {\r\n  background: #fff7f0;\r\n  box-shadow: 0 0 0 2px #f2cfb8;\r\n}\r\n\r\n.vacation-presence-name--business-trip {\r\n  background: #f5faef;\r\n  box-shadow: 0 0 0 2px #cfdfbd;\r\n}\r\n\r\n.vacation-presence-name[tabindex]:focus {\r\n  outline: 2px solid currentColor;\r\n  outline-offset: 3px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/vacation/vacation-presence-badge.component.css
// module id = ../../../../../src/app/content-page/common/vacation/vacation-presence-badge.component.css
// module chunks = main